<template>
  <div class="currency-icon">
    <img
      class="currency-icon__img"
      :src="`${apiUrl}/images/ticker/icon/${currencyId}/preview.png`"
      @load="iconIsLoaded = true"
      @error="showErrorStub()"
      v-show="iconIsLoaded"
    >
    <icon-stub
      v-if="!iconIsLoaded"
      class="currency-icon__stub"
      :class="{'currency-icon__stub_gray': !iconNotFound, 'currency-icon__stub_red': iconNotFound}"
    />

  </div>
</template>

<script>
import { apiUrl } from 'src/utils/config';
import { IconStub } from 'Icons';

export default {
  data: () => ({
    iconIsLoaded: false,
    iconNotFound: false,
  }),
  components: {
    IconStub,
  },
  props: {
    currencyId: Number,
  },
  computed: {
    apiUrl: () => apiUrl,
  },
  methods: {
    showErrorStub() {
      this.iconIsLoaded = false;
      this.iconNotFound = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  .currency-icon {
    position: relative;
    &__stub {
      position: absolute;
      top: 0;
      left: 0;
    }
    &__img {
      width: 100%;
      position: relative;
      z-index: 1;
    }
  }
  .currency__g {
    transform: scaleX(0.99);
  }
  .search-control__result:hover,
  .search-control__result_selected,
  .table__tr:hover{
    .currency-icon {
      position: relative;
      &__img,
      &__stub {
        z-index: 1;
        position: relative;
      }
      &:after {
        content: '';
        background: $white-color2;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: block;
        position: absolute;
        top: 4px;
        left: -6px;
      }
    }
  }
  .search-control__result:hover,
  .search-control__result_selected {
    .currency-icon {
      &__img,
      &__stub {
        width: 20px;
      }
    }
  }
  .table__tr:hover .currency-icon:after {
    top: -8px;
    left: -8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/uikit/CurrencyIcon.vue